"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("@pbl/pbl-react-core/lib/models/draws/types");
var loyalty_1 = require("@pbl/pbl-react-core/lib/models/loyalty");
var types_2 = require("@pbl/pbl-react-core/lib/models/loyalty/types");
var action_type_util_1 = require("../../action-type.util");
var INITIAL_STATE = {
    loading: false,
    userPoints: {
        id: null,
        redeemablePoints: 0,
        totalPoints: 0,
        activities: []
    },
    userRewards: new types_2.RewardList(),
    rewardCategories: [],
    rewards: new types_2.RewardList(),
    rewardCodes: [],
    rewardDigitalDownload: null,
    selectedReward: null,
    userActivities: new types_2.ActivityList(),
    selectedActivity: null,
    errorMessage: null,
    currentCampaign: null,
    activityCompleted: null,
    awarded: null,
    redeeming: null,
    uploading: false,
    maximumLimitReached: false,
    activityMappings: null,
    activityMapping: null,
    sweepStakeDraws: {},
    rewardEntries: 0,
    barcodeData: undefined,
    allRewards: new types_2.RewardList(),
    homeActivities: new types_2.ActivityList()
};
exports.default = (function (state, action) {
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case (0, action_type_util_1.REQUEST)(types_2.USER_POINTS):
        case (0, action_type_util_1.REQUEST)(types_2.REWARDS_CATEGORIES):
        case (0, action_type_util_1.REQUEST)(types_2.REWARDS):
        case (0, action_type_util_1.REQUEST)(types_2.ALL_REWARDS):
        case (0, action_type_util_1.REQUEST)(types_2.USER_REWARDS):
        case (0, action_type_util_1.REQUEST)(types_2.USER_ACTIVITIES):
        case (0, action_type_util_1.REQUEST)(types_2.CREDIT_USER_POINTS):
        case (0, action_type_util_1.REQUEST)(types_2.GET_CAMPAIGN):
        case (0, action_type_util_1.REQUEST)(types_2.ACTIVITY_DETAILS):
        case (0, action_type_util_1.REQUEST)(types_2.FETCH_INTEREST_ACTIVITY_TO_ACTIVITIES):
        case (0, action_type_util_1.REQUEST)(types_2.FETCH_REWARD_BARCODE_DATA):
        case (0, action_type_util_1.REQUEST)(types_2.REWARD):
        case (0, action_type_util_1.REQUEST)(types_2.FETCH_REWARD_ENTRY_DETAILS):
            return __assign(__assign({}, state), { loading: true });
        case (0, action_type_util_1.REQUEST)(types_2.REDEEM_REWARD):
            return __assign(__assign({}, state), { redeeming: true });
        case (0, action_type_util_1.SUCCESS)(types_2.USER_POINTS):
        case types_2.USER_POINTS:
            return __assign(__assign({}, state), { loading: false, errorMessage: null, userPoints: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_2.USER_REWARDS):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, userRewards: loyalty_1.Reward.JsonToRewards(action.payload) });
        case (0, action_type_util_1.SUCCESS)(types_2.REWARDS_CATEGORIES):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, rewardCategories: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_2.REWARDS):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, rewards: loyalty_1.Reward.JsonToRewards(action.payload) });
        case (0, action_type_util_1.SUCCESS)(types_2.ALL_REWARDS):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, allRewards: loyalty_1.Reward.JsonToRewards(action.payload) });
        case (0, action_type_util_1.SUCCESS)(types_2.FETCH_REWARD_BARCODE_DATA):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, barcodeData: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_2.REDEEM_REWARD):
            return __assign(__assign({}, state), { redeeming: false, errorMessage: null, rewardCodes: action.payload.codes, rewardDigitalDownload: action.payload.digital_download });
        case (0, action_type_util_1.SUCCESS)(types_2.CREDIT_USER_POINTS):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, awarded: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_2.USER_ACTIVITIES):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, userActivities: types_2.ActivityList.getCombinedSortedList(loyalty_1.Activity.JsonToActivities(action.payload), state.userActivities).getWebList() });
        case (0, action_type_util_1.SUCCESS)(types_2.FETCH_INTEREST_ACTIVITY_TO_ACTIVITIES):
            var interestActivity = loyalty_1.Activity.JsonToActivity(action.payload);
            return __assign(__assign({}, state), { loading: false, errorMessage: null, userActivities: types_2.ActivityList.getCombinedSortedList(state.userActivities, [
                    interestActivity
                ]).getWebList() });
        case (0, action_type_util_1.SUCCESS)(types_2.GET_CAMPAIGN):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, currentCampaign: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_2.ACTIVITY_DETAILS):
            var maximumLimitReached = !!action.payload &&
                !!action.payload.freq_cap &&
                !!action.payload.user_num_completions &&
                action.payload.freq_cap <= action.payload.user_num_completions;
            return __assign(__assign({}, state), { loading: false, errorMessage: null, maximumLimitReached: maximumLimitReached });
        case (0, action_type_util_1.SUCCESS)(types_2.FETCH_REWARD_ENTRY_DETAILS):
            return __assign(__assign({}, state), { loading: false, rewardEntries: action.payload ? action.payload : 0 });
        case (0, action_type_util_1.SUCCESS)(types_2.SET_SELECTED_ACTIVITY):
        case types_2.SET_SELECTED_ACTIVITY:
            return __assign(__assign({}, state), { loading: false, errorMessage: null, selectedActivity: loyalty_1.Activity.JsonToActivity(action.payload) });
        case types_1.FETCH_SWEEPSTAKE_DRAWS:
            return __assign(__assign({}, state), { errorMessage: null, sweepStakeDraws: action.payload });
        case types_2.SET_SELECTED_REWARD:
            return __assign(__assign({}, state), { loading: false, errorMessage: null, selectedReward: loyalty_1.Reward.JsonToReward(action.payload) });
        case (0, action_type_util_1.SUCCESS)(types_2.REWARD):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, selectedReward: loyalty_1.Reward.JsonToReward(action.payload) });
        case (0, action_type_util_1.FAILURE)(types_2.USER_POINTS):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload });
        case (0, action_type_util_1.FAILURE)(types_2.USER_REWARDS):
        case (0, action_type_util_1.FAILURE)(types_2.USER_ACTIVITIES):
        case (0, action_type_util_1.FAILURE)(types_2.CREDIT_USER_POINTS):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload, awarded: false });
        case (0, action_type_util_1.FAILURE)(types_2.REDEEM_REWARD):
            return __assign(__assign({}, state), { redeeming: false, errorMessage: action.payload.payload.errorDTO, rewardCodes: [], rewardDigitalDownload: null });
        case (0, action_type_util_1.FAILURE)(types_2.GET_CAMPAIGN):
        case (0, action_type_util_1.FAILURE)(types_2.ACTIVITY_DETAILS):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload });
        case (0, action_type_util_1.FAILURE)(types_2.FETCH_REWARD_BARCODE_DATA):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload, barcodeData: undefined });
        case (0, action_type_util_1.FAILURE)(types_2.REWARD):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload, selectedReward: null });
        case types_2.RESET_SELECTED_REWARD:
            return __assign(__assign({}, state), { selectedReward: null, rewardEntries: 0, barcodeData: undefined });
        case types_2.RESET_SELECTED_ACTIVITY:
            return __assign(__assign({}, state), { selectedActivity: null, currentCampaign: null });
        case types_2.UPDATE_USER_POINTS:
            return __assign(__assign({}, state), { loading: false, errorMessage: null, userPoints: action.payload });
        case types_2.ACTIVITY_COMPLETED:
            return __assign(__assign({}, state), { loading: false, errorMessage: null, activityCompleted: action.payload });
        case types_2.RESET_ACTIVITY_COMPLETED:
            return __assign(__assign({}, state), { loading: false, errorMessage: null, activityCompleted: null });
        case (0, action_type_util_1.REQUEST)(types_2.UPLOAD_PHOTO):
            return __assign(__assign({}, state), { errorMessage: null, uploading: true });
        case (0, action_type_util_1.SUCCESS)(types_2.UPLOAD_PHOTO):
            return __assign(__assign({}, state), { uploading: false, errorMessage: null });
        case (0, action_type_util_1.FAILURE)(types_2.UPLOAD_PHOTO):
            return __assign(__assign({}, state), { uploading: false, errorMessage: action.payload });
        case (0, action_type_util_1.SUCCESS)('authentication/LOGOUT'):
            return __assign(__assign({}, state), { userPoints: {
                    id: null,
                    redeemablePoints: 0,
                    totalPoints: 0,
                    activities: []
                }, userRewards: new types_2.RewardList() });
        case types_2.RESET_STATE:
            return __assign({}, INITIAL_STATE);
        case types_2.RESET_ERROR:
            return __assign(__assign({}, state), { errorMessage: null });
        default:
            return state;
    }
});
//# sourceMappingURL=reducers.js.map